// Global Types
import type {
  $FullBanner,
  $Model,
} from 'common.data';

// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';

// Services
import Services from '../../../../services';

// Components
import BannersSection from '../../CommonSections/BannersSection';

// Types
type $Props = {
  item: $Model<'Regatta'>;
};

type $State = {
  data: Array<$FullBanner>;
};

class BannersSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount(): void {
    this.getData();
    this.setupSocket();
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async getData(): Promise<void> {
    const {
      item,
    } = this.props;

    try {
      const data = await Services.Api.getRegattaBannersSectionData({
        RegattaId: item.id,
      });

      await this.setStateAsync({
        data,
      });
    } catch (err) {
      const error = err as Error;

      ErrorLog.exception(error);
    }
  }

  setupSocket(): void {
    const {
      item,
    } = this.props;

    Services.Socket.on({
      action: (data) => {
        if (data.RegattaId === item.id && data.modelName === 'Banner') {
          this.getData();
        }
      },
      type: Services.Socket.type.modelChangedEvent,
    });
  }

  render() {
    const {
      data,
    } = this.state;

    return (data.length > 0 ? (
      <BannersSection
        data={data}
        id={webSections[webPages.regattaPage].banners}
      />
    ) : null);
  }
}

export default BannersSectionView;
